export const FIELD_TEXT_NAME = 'field-copy-text';
